import { render, staticRenderFns } from "./VacanciesListTab.vue?vue&type=template&id=24737e50&scoped=true"
import script from "./VacanciesListTab.vue?vue&type=script&lang=js"
export * from "./VacanciesListTab.vue?vue&type=script&lang=js"
import style0 from "./VacanciesListTab.vue?vue&type=style&index=0&id=24737e50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24737e50",
  null
  
)

export default component.exports